import { ecoBwAnswers } from "@/views/partners/eco_bw/utils";

export default {
    computed: {
        ecoBwAnswers() {
            return ecoBwAnswers(this.customer)
        },
        familySize() {
            return this.ecoBwAnswers.familySize
        },
        yearsFarming() {
            return this.ecoBwAnswers.yearsFarming
        },
        transport() {
            return listOf(this.ecoBwAnswers.transport)
        },
        livelihood() {
            return listOf(this.ecoBwAnswers.livelihood)
        },
        ethnicity() {
            return this.ecoBwAnswers.ethnicity
        },
        regionLocation() {
            return this.ecoBwAnswers.region
        },
    },
}

function listOf(value) {
    return Array.isArray(value) ? value.join(', ') : value
}
